<template>
  <div class="Inspection6">
    <h1 id="heading">Bewertung der Erfahrung des Anlagenherstellers mit gleichartigen Systemen</h1>
    <v-divider></v-divider>
    <div>
      <v-data-table
        :headers="headers"
        :items-per-page="5"
        :items="items"
        item-key="name"
        class="DataTable"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.name }}</td>
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.assess }}</td>
            <td>
              <input
                type="radio"
                v-model="assessment"
                :key="props.item.assess"
                :value="props.item.assess"
              >
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="description">
        <v-dialog v-model="dialog" max-width="500px" :retain-focus="false">
          <template v-slot:activator="{ on }">
            <v-btn color="green" slot="activator" x-small fab v-on="on">
              <v-icon color="white" small>fas fa-info</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-toolbar color="green" height="50px">
              <v-toolbar-title style="color: white; font-size: 150%">Erfahrung des Anlagengerstellers</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn @click="close" small icon>
                <v-icon color="white">fas fa-times</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text style="font-size: 100%;">
              <p><br>
                a) Sind Ihnen <u>positive Referenzen</u> solcher Systeme im Feld bekannt, dann
ist als relative Bewertung „0“ anzugeben.<br><br>
b) Sind Ihnen <u>solche Systeme im Feld nicht bekannt</u>, kontaktieren Sie
Ihren Anlagenhersteller um festzustellen, ob Ihre Anlage eine
„Erstanlage“ bzw. „Pilotanlage“ ist. Falls es sich um eine Erst- bzw.
Pilotanlage handelt, dann ist als relative Bewertung „2“ anzugeben.
              </p>
              <br>
              <p style="text-decoration: underline;"></p>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
      <v-divider></v-divider>
      <v-btn color="blue" @click="nextPage" small fab>
        <v-icon color="white">fas fa-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Inspection6",
  props: ["assessmen"],
  data() {
    return {
      assessment: 0,
      assessName: "",
      assessHeader: "",
      dialog: false,
      items: [
        { name: "Positive Referenz des Systems", assess: 0 },
        { name: "Pilotanlage", assess: 2 }
      ],
      headers: [
        {
          text: "Litzen- und vollverschlossene Seile",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Relative Bewertung", sortable: false, value: "assess" }
      ]
    };
  },
  methods: {
    nextPage() {
      switch (this.assessment) {
        case 0:
          this.assessName = "Positive Referenz des Systems";
          break;
        case 2:
          this.assessName = "Pilotanlage";
          break;
      }
      this.assessmen = this.assessmen + this.assessment;
      this.assessHeader = "Erfahrung des Anlagengerstellers";

      this.$emit("assessChanged", this.assessmen);
      this.$emit("assessmentName", this.assessName);
      this.$emit("assessmentHeader", this.assessHeader);
      this.$emit("assessmentActual", this.assessment);
      this.$emit("InspBefore", false);
      this.$emit("InspActual", true);
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>

<style>
.Inspection6 {
  background-color: white;
  width: 70%;
  margin: 1% auto 0% auto;
  border: 1px solid black;
  border-radius: 5px;
  text-align: center;
}

.DataTable {
  width: 90%;
  margin-left: 5%;
}

#heading {
  font-size: 200%;
}
</style>
